import { ArrowRight } from 'lucide-react';

import { SectionWrapper } from '../components/SectionWrapper';
import { TimelineNode } from '../components/TimelineNode';

import styles from './UCLATimelineSection.module.css';

const timeline = [
  { label: '1 course built', value: '1' },
  { label: '5 courses launched', value: '5' },
  { label: 'Weeks to build', value: 'Weeks' },
  { label: 'Hours for faculty review', value: 'Hours' },
] as const;

export function UCLATimelineSection() {
  return (
    <SectionWrapper background="white" data-testid="institutions-section-ucla">
      <div className={styles.layout}>
        <aside className={styles.storyCard}>
          <p className={styles.logo}>Kudu · UCLA</p>
          <figure className={styles.quoteFigure}>
            <span aria-hidden="true" className={styles.quoteMark} data-accent="amber">
              “
            </span>
            <blockquote>
              &quot;Instead of banning AI, this UCLA literature class embraces
              it.&quot;
            </blockquote>
            <figcaption>— LAist, February 2025</figcaption>
          </figure>
          <div className={styles.pressLinks}>
            <a
              href="https://laist.com/news/education/ucla-humanities-courses-artificial-intelligence-chatgpt-kudu"
              rel="noreferrer"
              target="_blank"
            >
              LAist
            </a>
          </div>
        </aside>

        <div className={styles.copy}>
          <h2 className={styles.title}>
            One professor&apos;s success becomes a department&apos;s playbook.
          </h2>
          <p className={styles.body}>
            UCLA started with one AI-enabled humanities course that had no
            off-the-shelf fit. Kudu turned years of faculty materials into a
            complete course in weeks, with faculty review measured in hours.
          </p>
          <p className={styles.body}>
            That single success became a repeatable department pattern: more
            courses launched, more faculty supported, and a clearer institutional
            approach to AI courseware.
          </p>
          <div aria-label="UCLA adoption timeline" className={styles.timeline}>
            {timeline.map((item) => (
              <TimelineNode key={item.label} {...item} />
            ))}
          </div>
          <a
            className={styles.link}
            href="https://newsroom.ucla.edu/stories/comparative-literature-zrinka-stahuljak-artificial-intelligence"
            rel="noreferrer"
            target="_blank"
          >
            Read the UCLA story <ArrowRight aria-hidden="true" size={16} />
          </a>
        </div>
      </div>
    </SectionWrapper>
  );
}
